import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';


export default function SelectInput({ data, className, defaultValue, value, onChange }) {

  return (
    <>
      <Select
        value={value==''?defaultValue:value}
        defaultValue={defaultValue}
        className={className}
        onChange={onChange}
        label="j"
      >
        {data.map(item => (
          <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
        ))}
      </Select>
    </>
  );
}
